import React, {createRef, useEffect, useState} from 'react';
import styled from 'styled-components'
import ReactDOM from 'react-dom';
import PrivateclassItem from "./privateclass_item";
import MasterclassItem from '../masterclass_tool/masterclass_item';

export default function PrivateclassOfCourse({courseId}) {
    const [menuActive, setMenuActive] = useState('next')
    const [classType, setClassType] = useState('')
    const [items, setItems] = useState([])
    const [next, setNext] = useState([])
    const [old, setOld] = useState([])

    useEffect(() => {
        fetch('/ajax/privateclass/fetch-next')
            .then(r => r.json())
            .then(r => {
                setNext(r)
                setItems(r)
            })

        fetch('/ajax/privateclass/fetch-old')
            .then(r => r.json())
            .then(r => setOld(r))
    }, [])

    useEffect(() => {
        const listener = (event) => {
            const menuitem = event.detail
            setMenuActive(menuitem)
        }

        document.addEventListener('privateclass_menu_tabs', listener)

        return () => {
            document.removeEventListener('privateclass_menu_tabs', listener)
        }
    }, []);

    useEffect(() => {
        const listener = (event) => {
            const query = event.detail
            setClassType(query)
        }

        document.addEventListener('master_private_class_switch', listener)

        return () => {
            document.removeEventListener('master_private_class_switch', listener)
        }
    }, []);

    useEffect(() => {
        const listener = (event) => {
            const query = event.detail

            if(query.length > 0) {
                setItems(items => {

                    return items.filter(item => {
                        const search = `${item.name.toLowerCase()} ${item.description.toLowerCase()}`
                        return search.indexOf(query) > -1
                    })
                })
            } else {
                resetContent()
            }
        }

        document.addEventListener('masterclass_search_query', listener)

        return () => {
            document.removeEventListener('masterclass_search_query', listener)
        }
    }, [menuActive])

    function resetContent() {
        if(menuActive === 'next') setItems(next)
        if(menuActive === 'old') setItems(old)

        if(classType) {
            setItems(items => {
                return items.filter(item => {
                    const currentType = `${item.class_type.toLowerCase()}`
                    return currentType.indexOf(classType) > -1
                })
            })
        }
    }

    useEffect(() => {
        resetContent()
    }, [menuActive, classType])

    let itemsSorted = items.map(a => {
        const date = new Date();
        const parts = a.starts_at.split(' ')
        const partsDate = parts[0].split('/')

        date.setFullYear(partsDate[2], partsDate[1], partsDate[0])

        return {
            ...a,
            timeSS: date.getTime()
        }
    })

    if (menuActive !== 'next') {
        itemsSorted.sort((a , b) => { return b.timeSS - a.timeSS })
    } else  {
        itemsSorted.sort((a , b) => { return b.timeSS + a.timeSS })
    }

    return (
        <Container>
            {itemsSorted.length === 0 && (<NoContentMessage>No hay clases disponibles</NoContentMessage>)}
            {itemsSorted.map(item => {
                if (item.class_type === 'PRIVATE')
                    return <PrivateclassItem
                        isDone={item.is_done}
                        hasSuscription={false}
                        isFree={item.is_free == 1}
                        slug={item.slug}
                        key={`masterclass_item_${item.slug}`}
                        startsDay={item.start_day_label}
                        startsMonth={item.start_day_month}
                        starsHour={item.start_day_time}
                        title={item.name}
                        price={item.price}
                        description={item.description}
                        teacher={item.teacher}
                        hasAccess={item.is_registered}
                    />

                if (item.class_type === 'MASTER')
                    return <MasterclassItem
                        isDone={item.is_done}
                        hasSuscription={false}
                        isFree={item.is_free == 1}
                        slug={item.slug}
                        key={`masterclass_item_${item.slug}`}
                        startsDay={item.start_day_label}
                        startsMonth={item.start_day_month}
                        starsHour={item.start_day_time}
                        title={item.name}
                        price={item.price}
                        description={item.description}
                        teacher={item.teacher}
                        hasAccess={item.is_registered}
                    />
            } )}
        </Container>
    )
}

const NoContentMessage = styled.div`
    text-align: center;
    margin: 12px 0;


`
const Container = styled.div`
    padding: 8px;
    padding-top: 24px;
    padding-bottom: 80px;
    height: calc(100vh - 280px);
    overflow-y: scroll;
`

const elm = document.getElementById('privateclasses-of-course');

if (elm) {
    const courseId = elm.attributes['course-id'].value
    ReactDOM.render(<PrivateclassOfCourse
        courseId={courseId}
    />, elm);
}
